function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useState } from 'react';
import { Button, ConfirmationModal, PasswordField, TextButton, Typography } from 'seagull';
import styles from "./SecureLoginModal.module.scss";
import { useStore, useStoreActions } from "../../store/store-context";
import { Controller, useForm } from 'react-hook-form';
import IntuitButton from "../IntuitButton/IntuitButton";
import GoogleButton from "../GoogleButton/GoogleButton";
import { useHistory } from 'react-router-dom';
import { useEventReporter } from "../../event-reporter";
import { routes } from "../../constants";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SecureLoginModal = _ref => {
  let {
    dismissModal,
    isDismissDisabled = false
  } = _ref;
  const {
    api,
    logBI
  } = useStoreActions();
  const {
    reportToHeap
  } = useEventReporter();
  const [step, setStep] = useState('selectIdentity');
  const form = useForm({
    mode: 'all',
    defaultValues: {
      password: '',
      ['confirm-password']: ''
    }
  });
  const {
    handleSubmit
  } = form;
  const {
    SET_IDENTITY_ONLY_TOKEN_FE
  } = useFeatureFlags();
  const setPassword = async data => {
    logBI(18102);
    logBI(18902);
    reportToHeap('secure-login', 'click', 'client-click-set-login-password');
    const {
      password
    } = data;
    if (SET_IDENTITY_ONLY_TOKEN_FE) {
      await api.auth.setPassword(password);
    } else {
      await api.auth.editUserDetails({
        password
      });
    }
    dismissModal(true);
  };
  return /*#__PURE__*/_jsxs("div", {
    "data-testid": "secure-login-modal",
    children: [step === 'selectIdentity' && /*#__PURE__*/_jsx(SelectIdentityTypeStep, {
      dismissModal: dismissModal,
      onCreatePassword: () => {
        logBI(18901);
        setStep('setPassword');
      },
      isDismissDisabled: isDismissDisabled
    }), step === 'setPassword' && /*#__PURE__*/_jsx(SetPasswordStep, {
      dismissModal: dismissModal,
      onClickBack: () => setStep('selectIdentity'),
      onContinue: handleSubmit(setPassword),
      form: form,
      isDismissDisabled: isDismissDisabled
    })]
  });
};
const SelectIdentityTypeStep = _ref2 => {
  let {
    onCreatePassword,
    dismissModal,
    isDismissDisabled
  } = _ref2;
  const userInfo = useStore(state => state.userInfo);
  const history = useHistory();
  const {
    logBI
  } = useStoreActions();
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Secure login required",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.textContainer,
        children: /*#__PURE__*/_jsx(Typography, {
          children: "Creating a Service Provider account requires a secure authentication method. Choose from the following options:"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.formContainer,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.formComponentsWrapper,
          children: [/*#__PURE__*/_jsx(Button, {
            skin: "darkSecondary",
            size: "medium",
            fluid: true,
            "data-testid": "create-password-btn",
            onClick: onCreatePassword,
            children: "Create a password"
          }), /*#__PURE__*/_jsx(GoogleButton, {
            ensureEmail: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email(),
            onAuthSuccess: () => {
              logBI(18903);
              history.push(routes.home);
            }
          }), /*#__PURE__*/_jsx(IntuitButton, {
            ensureEmail: userInfo === null || userInfo === void 0 ? void 0 : userInfo.email()
          })]
        })
      })]
    }),
    secondaryButtonLabel: !isDismissDisabled ? 'Cancel' : undefined,
    secondaryButtonTestid: "cancel-btn",
    onSecondaryButtonClick: () => {
      if (isDismissDisabled) return;
      dismissModal(false);
    },
    cancelButtonDisabled: isDismissDisabled,
    onCloseButtonClick: () => {
      if (isDismissDisabled) return;
      dismissModal(false);
    },
    "data-testid": "select-identity-step"
  });
};
const SetPasswordStep = _ref3 => {
  let {
    onClickBack,
    onContinue,
    form,
    dismissModal,
    isDismissDisabled
  } = _ref3;
  const {
    control,
    getValues
  } = form;
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Set your password",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx(TextButton, {
        underline: "none",
        "data-testid": "back-btn",
        onClick: onClickBack,
        children: '< Back'
      }), /*#__PURE__*/_jsx("div", {
        className: styles.formContainer,
        children: /*#__PURE__*/_jsxs("form", {
          className: styles.formComponentsWrapper,
          children: [/*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "password",
            defaultValue: "",
            rules: {
              required: true,
              minLength: {
                value: 10,
                message: 'Use 10 or more characters'
              },
              deps: 'confirm-password'
            },
            render: _ref4 => {
              var _fieldState$error;
              let {
                field,
                fieldState
              } = _ref4;
              return /*#__PURE__*/_jsx(PasswordField, _objectSpread(_objectSpread({}, field), {}, {
                error: !!fieldState.error,
                helperText: (_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message,
                "data-testid": "password",
                label: "Password"
              }));
            }
          }), /*#__PURE__*/_jsx(Controller, {
            control: control,
            name: "confirm-password",
            defaultValue: "",
            rules: {
              required: true,
              validate: value => {
                const doPasswordsMatch = getValues('password') === value;
                return doPasswordsMatch || 'Passwords do not match';
              }
            },
            render: _ref5 => {
              var _fieldState$error2;
              let {
                field,
                fieldState
              } = _ref5;
              return /*#__PURE__*/_jsx(PasswordField, _objectSpread(_objectSpread({}, field), {}, {
                error: !!fieldState.error,
                helperText: (_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message,
                "data-testid": "confirm-password",
                label: "Re-enter password"
              }));
            }
          })]
        })
      })]
    }),
    primaryButtonLabel: "Continue",
    primaryButtonTestid: "continue-btn",
    onPrimaryButtonClick: onContinue,
    secondaryButtonLabel: !isDismissDisabled ? 'Cancel' : undefined,
    secondaryButtonTestid: "cancel-btn",
    onSecondaryButtonClick: () => {
      if (isDismissDisabled) return;
      dismissModal(false);
    },
    onCloseButtonClick: () => {
      if (isDismissDisabled) return;
      dismissModal(false);
    },
    cancelButtonDisabled: isDismissDisabled,
    "data-testid": "set-password-step"
  });
};